import { apiService } from "./apiService";

export function fetchCustomeReferralCode(data) {
  return apiService({
    method: "POST",
    url: "/api/customReferralCode/list",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function fetchDWRequests(data) {
  return apiService({
    method: "POST",
    url: "/api/customReferralCode/dw/requests",
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function fetchGetOrders(data) {
    return apiService({
        method: "POST",
        url: "/api/admin/orders",
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
